var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFingeryes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-outline",
    d: "M85.72,181.14a15.92,15.92,0,0,1-15.91-15.91A319.72,319.72,0,0,1,89.1,55.44,15.91,15.91,0,1,1,119,66.34a288,288,0,0,0-17.36,98.89A15.92,15.92,0,0,1,85.72,181.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-outline",
    d: "M85.72,181.14a15.92,15.92,0,0,1-15.91-15.91,154.2,154.2,0,0,1,68-127.92,15.91,15.91,0,0,1,17.81,26.38,122.41,122.41,0,0,0-54,101.54A15.92,15.92,0,0,1,85.72,181.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-outline",
    d: "M130,225.41a60.19,60.19,0,1,1,42.56-102.74,15.92,15.92,0,0,1,0,22.5,16.25,16.25,0,0,1-3,2.38,16.35,16.35,0,0,1,3.8-.68,15.9,15.9,0,0,1,16.77,15c.07,1.1.1,2.23.1,3.35A60.25,60.25,0,0,1,130,225.41Zm0-88.55a28.37,28.37,0,1,0,28.36,28.37c0-.53,0-1.06,0-1.58A15.88,15.88,0,0,1,166,149.13a15.93,15.93,0,0,1-15.95-4A28.14,28.14,0,0,0,130,136.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-outline",
    d: "M69.81,165.23a101.22,101.22,0,0,1,93-100.88,15.91,15.91,0,1,1,2.57,31.72,68.47,68.47,0,0,0-29,9.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "svg-outline",
    d: "M111.78,107.86a60.21,60.21,0,0,1,60.78,14.81,15.92,15.92,0,0,1,0,22.5,16.25,16.25,0,0,1-3,2.38,16.35,16.35,0,0,1,3.8-.68,15.9,15.9,0,0,1,16.77,15c.07,1.1.1,2.23.1,3.35a60.19,60.19,0,0,1-120.38,0M130,136.86a28.37,28.37,0,1,0,28.36,28.37c0-.53,0-1.06,0-1.58A15.88,15.88,0,0,1,166,149.13a15.93,15.93,0,0,1-15.95-4A28.14,28.14,0,0,0,130,136.86Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingeryes);
export default __webpack_public_path__ + "static/media/fingeryes.27f82d7d.svg";
export { ForwardRef as ReactComponent };